<div [hidden]="otpSent" class="dialog-box">
  <div class="dialog-content sign-in-dialog">
    <h2>Sign In to give & get <br>
      <span class="color-primary">help</span></h2>
    <p>“Helping others is the way we help ourselves”</p>
    <mat-form-field class="field" appearance="outline">
      <mat-label>Email Address</mat-label>
      <label>
        <input name="email" [formControl]="email" autocomplete="off" matInput placeholder="Enter your email address" type="text">
      </label>
      <mat-error *ngIf="!!email.errors?.required">
        Email is <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="!!email.errors?.pattern || !!email.errors?.email">
        <strong>Invalid</strong> email
      </mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" *ngIf="!isLoading" (click)="onContinue()">CONTINUE</button>
    <mat-spinner [strokeWidth]="3" [diameter]="30" color="primary" *ngIf="!!isLoading"></mat-spinner>
    <p>By continuing, you agree to the <br> <a routerLink="/privacy" mat-dialog-close>Privacy Policy</a> and <a routerLink="/terms" mat-dialog-close>Terms & Conditions</a>.</p>
  </div>
</div>

<div [hidden]="!otpSent" class="dialog-box">
  <div class="dialog-content verify-otp-dialog">
    <h2>Verify with OTP</h2>
    <p>Sent to {{email.value}}</p>
    <mat-form-field class="field" appearance="outline">
      <mat-label>OTP</mat-label>
      <label>
        <input [formControl]="otp" matInput placeholder="Enter One Time Password" autocomplete="off" type="text">
      </label>
      <mat-error *ngIf="!!otp.errors?.required">
        OTP is <strong>required</strong>
      </mat-error>
      <mat-error *ngIf="!!otp.errors?.pattern">
        <strong>Invalid</strong> OTP
      </mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" *ngIf="!isLoading" (click)="verifyOtp()">VERIFY</button>
    <mat-spinner [strokeWidth]="3" [diameter]="30" color="primary" *ngIf="!!isLoading"></mat-spinner>
  </div>
</div>

